import 'whatwg-fetch'

import { FlagProvider, IToggle } from '@unleash/nextjs'
import getConfig from 'next/config'
import React, { PropsWithChildren } from 'react'

import { releaseStage } from '@/lib/config'

const { publicRuntimeConfig } = getConfig()
const { REGION } = publicRuntimeConfig

export function UnleashContextProvider({
  sessionId,
  userId,
  venueSlug,
  toggles,
  children,
}: PropsWithChildren<{
  sessionId: string
  userId?: string
  venueSlug: string | null
  toggles?: IToggle[]
}>) {
  return (
    <FlagProvider
      config={{
        url: 'https://app.unleash-hosted.com/euaa002/api/frontend',
        clientKey: 'd14e2618cad473a8f23e328',
        appName: 'serve-frontend',
        environment: releaseStage,
        bootstrap: toggles,
        context: {
          sessionId,
          userId,
          properties: {
            ...(REGION && { region: REGION }),
            ...(venueSlug && { venueSlug }),
          },
        },
      }}
    >
      {children}
    </FlagProvider>
  )
}
